export default __webpack_public_path__ + "static/media/youtube.8df6db88.svg";